import { ICarbonDetailFormValues } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider/types';
import dayjs, { Dayjs } from 'dayjs';

type MasterDataType = {
  id: number;
  nameTh: string;
  nameEn: string;
};

const findMasterData = (
  id: number | string | undefined,
  masterData: MasterDataType[]
) => masterData.find((data) => data.id === id);

export const mapCarbonToTable = (
  CarbonDetails: ICarbonDetailFormValues[],
  CarbonMasterData: MasterDataType[]
) => {
  return CarbonDetails.map((detail, index) => {
    const scopeData = findMasterData(detail.scopeId, CarbonMasterData);
    const organizationData = findMasterData(
      detail.organizationId,
      CarbonMasterData
    );

    return {
      ...detail,
      id: detail?.id ?? `NEW-${index + 1}`,
      scope: {
        scopeId: detail.scopeId,
        nameScopeTh: scopeData?.nameTh,
        nameScopeEn: scopeData?.nameEn,
      },
      isGuarantee: detail.isGuarantee,
      organization: {
        organizationId: organizationData?.id,
        organizationTh: detail?.organizationTh,
        organizationEn: detail?.organizationEn,
      },
    };
  });
};

export const setDateMonthToFirst = (date: Dayjs | undefined) => {
  if (!date) return undefined;
  return dayjs(date).set('date', 1).set('month', 0);
};
